/**
 * Display order for works on the site and letter menu.
 * Order 1 = top, 2 = below, 3 = further down, etc.
 * Works without Order fall back after numbered items (by year).
 */
const FALLBACK_BASE = 100000

export function postSortKey (post) {
  if (!post) return FALLBACK_BASE
  if (typeof post.sortOrder === 'number' && !Number.isNaN(post.sortOrder)) {
    return post.sortOrder
  }
  const year = typeof post.year === 'number' ? post.year : 0
  return FALLBACK_BASE - year
}

export function comparePostsByDisplayOrder (a, b) {
  const diff = postSortKey(a) - postSortKey(b)
  if (diff !== 0) return diff
  return (b.date || 0) - (a.date || 0)
}
